import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const servicos = [
  {
    title: "Benefícios Corporativos",
    desc: "Estruturação completa do pacote de benefícios com foco em atratividade, retenção e custo-eficiência.",
    icon: "ri-building-2-line",
    tag: "Estratégia",
    slug: "beneficios-corporativos",
    img: "https://readdy.ai/api/search-image?query=modern%20corporate%20office%20team%20meeting%20professional%20business%20people%20discussing%20strategy%2C%20clean%20minimalist%20workspace%2C%20warm%20golden%20light%2C%20premium%20executive%20environment%2C%20black%20and%20white%20tones%20with%20golden%20accents&width=600&height=400&seq=serv001&orientation=landscape",
  },
  {
    title: "Plano de Saúde",
    desc: "Análise, negociação e gestão de planos de saúde empresariais com as melhores operadoras do mercado.",
    icon: "ri-heart-pulse-line",
    tag: "Saúde",
    slug: "plano-de-saude",
    img: "https://readdy.ai/api/search-image?query=happy%20smiling%20family%20of%20four%20parents%20and%20two%20children%20laughing%20together%20outdoors%20in%20warm%20golden%20sunlight%2C%20genuine%20joyful%20expressions%2C%20natural%20candid%20moment%2C%20green%20park%20background%20with%20soft%20bokeh%2C%20lifestyle%20family%20photography%2C%20bright%20warm%20tones%2C%20feeling%20of%20health%20wellbeing%20and%20protection%2C%20premium%20authentic%20aesthetic&width=600&height=400&seq=serv002-v2&orientation=landscape",
  },
  {
    title: "Plano Odontológico",
    desc: "Soluções odontológicas empresariais com ampla rede credenciada e cobertura adequada ao perfil da equipe.",
    icon: "ri-tooth-line",
    tag: "Odonto",
    slug: "plano-odontologico",
    img: "https://readdy.ai/api/search-image?query=beautiful%20confident%20person%20with%20bright%20radiant%20white%20smile%20showing%20perfect%20healthy%20teeth%2C%20closeup%20portrait%2C%20warm%20natural%20lighting%2C%20genuine%20happy%20expression%2C%20clean%20simple%20neutral%20background%2C%20professional%20dental%20health%20concept%2C%20premium%20lifestyle%20photography%2C%20soft%20golden%20tones%2C%20feeling%20of%20confidence%20and%20wellbeing&width=600&height=400&seq=serv003-v2&orientation=landscape",
  },
  {
    title: "Seguro de Vida",
    desc: "Proteção financeira para colaboradores e familiares com coberturas personalizadas e custo acessível.",
    icon: "ri-shield-user-line",
    tag: "Proteção",
    slug: "seguro-de-vida",
    img: "https://readdy.ai/api/search-image?query=family%20protection%20insurance%20concept%2C%20professional%20business%20people%20shaking%20hands%2C%20trust%20and%20security%20theme%2C%20modern%20corporate%20environment%2C%20warm%20golden%20light%2C%20sophisticated%20minimal%20design&width=600&height=400&seq=serv004&orientation=landscape",
  },
  {
    title: "Previdência Privada",
    desc: "Planejamento previdenciário corporativo para retenção de talentos e benefício fiscal para a empresa.",
    icon: "ri-safe-2-line",
    tag: "Previdência",
    slug: "previdencia-privada",
    img: "https://readdy.ai/api/search-image?query=financial%20planning%20investment%20concept%2C%20professional%20advisor%20with%20charts%20and%20graphs%2C%20modern%20office%20environment%2C%20wealth%20management%20premium%20concept%2C%20sophisticated%20business%20atmosphere&width=600&height=400&seq=serv005&orientation=landscape",
  },
  {
    title: "Consultoria Estratégica",
    desc: "Visão 360° sobre a gestão de benefícios com relatórios, indicadores e recomendações baseadas em dados.",
    icon: "ri-line-chart-line",
    tag: "Consultoria",
    slug: "consultoria-estrategica",
    img: "https://readdy.ai/api/search-image?query=business%20strategy%20consulting%20data%20analytics%20dashboard%2C%20modern%20office%20with%20screens%20showing%20charts%2C%20professional%20consultant%20analyzing%20data%2C%20premium%20corporate%20environment%2C%20sophisticated%20minimal%20workspace&width=600&height=400&seq=serv006&orientation=landscape",
  },
  {
    title: "Gestão de Contratos",
    desc: "Administração ativa de contratos, renovações, reajustes e compliance para proteger os interesses da empresa.",
    icon: "ri-file-list-3-line",
    tag: "Gestão",
    slug: "gestao-de-contratos",
    img: "https://readdy.ai/api/search-image?query=contract%20management%20legal%20documents%20professional%20business%2C%20modern%20office%20desk%20with%20papers%20and%20laptop%2C%20corporate%20legal%20environment%2C%20clean%20minimalist%20workspace%2C%20professional%20business%20setting&width=600&height=400&seq=serv007&orientation=landscape",
  },
];

export default function Servicos() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".serv-card").forEach((card, i) => {
              setTimeout(() => card.classList.add("serv-visible"), i * 80);
            });
          }
        });
      },
      { threshold: 0.05 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="servicos" className="py-16 lg:py-20 bg-[#F8F8F6]" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="w-6 h-px bg-black" />
              <span className="text-black text-xs font-semibold tracking-widest uppercase">
                Nossas soluções
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black leading-tight">
              Tudo que sua empresa precisa em benefícios
            </h2>
          </div>
          <p className="text-black/70 text-base leading-relaxed max-w-sm lg:text-right">
            Soluções integradas para uma gestão de benefícios mais eficiente, estratégica e humana.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {servicos.map((serv) => (
            <div
              key={serv.title}
              onClick={() => navigate(`/servicos/${serv.slug}`)}
              className="serv-card opacity-0 translate-y-6 transition-all duration-500 group relative rounded-2xl overflow-hidden cursor-pointer h-64"
            >
              {/* Background Image */}
              <img
                src={serv.img}
                alt={serv.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/10 group-hover:from-black/95 transition-all duration-300" />

              {/* Tag */}
              <div className="absolute top-4 right-4">
                <span className="bg-[#FBC52D] text-black text-xs font-bold px-3 py-1 rounded-full">
                  {serv.tag}
                </span>
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10 mb-3">
                  <i className={`${serv.icon} text-white text-base`} />
                </div>
                <h3 className="text-white font-bold text-base mb-1.5">{serv.title}</h3>
                <p className="text-white/65 text-xs leading-relaxed line-clamp-2 group-hover:text-white/80 transition-colors">
                  {serv.desc}
                </p>
              </div>
            </div>
          ))}

          {/* CTA Card */}
          <div className="serv-card opacity-0 translate-y-6 transition-all duration-500 bg-[#FBC52D] rounded-2xl p-5 flex flex-col justify-between cursor-pointer group hover:bg-[#d4a800] transition-colors h-64">
            <div>
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-black/10 mb-3">
                <i className="ri-arrow-right-up-line text-black text-xl" />
              </div>
              <h3 className="text-black font-bold text-lg mb-2">Não encontrou o que precisa?</h3>
              <p className="text-black/70 text-sm leading-relaxed">
                Fale com um especialista e descubra a solução ideal para sua empresa.
              </p>
            </div>
            <button
              onClick={() => document.querySelector("#contato")?.scrollIntoView({ behavior: "smooth" })}
              className="whitespace-nowrap self-end bg-black text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-gray-900 transition-colors"
            >
              Falar agora
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .serv-visible {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}